import { render } from "./PharmacyQueueTab.vue?vue&type=template&id=93515dd0"
import script from "./PharmacyQueueTab.vue?vue&type=script&lang=js"
export * from "./PharmacyQueueTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__